webpackJsonp([72776394686286],{

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin: 0px 0px 10px;\n  &:last-of-type {\n    margin-bottom: 20px;\n  }\n  border-left: 5px solid ', ';\n'], ['\n  margin: 0px 0px 10px;\n  &:last-of-type {\n    margin-bottom: 20px;\n  }\n  border-left: 5px solid ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-weight: 300;\n  line-height: 1.8rem;\n  font-size: 1.5rem;\n  margin: 0px 0px .5rem;\n'], ['\n  font-weight: 300;\n  line-height: 1.8rem;\n  font-size: 1.5rem;\n  margin: 0px 0px .5rem;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  line-height: 1.5rem;\n  font-size: 1rem;\n  margin: 0px 0px .5rem;\n  font-weight: 500;\n  opacity: 0.8;\n'], ['\n  line-height: 1.5rem;\n  font-size: 1rem;\n  margin: 0px 0px .5rem;\n  font-weight: 500;\n  opacity: 0.8;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  line-height: 1.5rem;\n  font-size: 1.1rem;\n  font-weight: 300;\n  margin: 0px 0px 0;\n  opacity: 0.8;\n  & p:last-of-type {\n    margin-bottom: 0;\n  }\n'], ['\n  line-height: 1.5rem;\n  font-size: 1.1rem;\n  font-weight: 300;\n  margin: 0px 0px 0;\n  opacity: 0.8;\n  & p:last-of-type {\n    margin-bottom: 0;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Card = __webpack_require__(30);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var marked = __webpack_require__(12);
	marked.setOptions({
	  gfm: true,
	  tables: true,
	  breaks: true,
	  sanitize: true
	});
	
	var News_Item = function News_Item(props) {
	  return _react2.default.createElement(
	    NewsCard,
	    { type: props.news.type && props.news.type[0] },
	    _react2.default.createElement(
	      NewsDate,
	      null,
	      new Date(props.news.date).toLocaleDateString()
	    ),
	    _react2.default.createElement(
	      NewsTitle,
	      null,
	      props.news.title
	    ),
	    props.news.description && _react2.default.createElement(NewsDetails, {
	      dangerouslySetInnerHTML: { __html: marked(props.news.description.description, { sanitize: true }) } })
	  );
	};
	
	exports.default = News_Item;
	
	
	var NewsCard = _Card2.default.extend(_templateObject, function (props) {
	  return props.type == 'Award' && 'gold' || props.type == 'Meeting' && 'rebeccapurple' || props.type == 'Position' && 'tomato' || props.type == 'Poster' && 'mediumseagreen' || props.type == 'Presentation' && 'steelblue' || props.type == 'Publication' && 'lightblue' || '#333';
	});
	
	var NewsTitle = _styledComponents2.default.h2(_templateObject2);
	
	var NewsDate = _styledComponents2.default.p(_templateObject3);
	
	var NewsDetails = _styledComponents2.default.p(_templateObject4);
	module.exports = exports['default'];

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _News_Item = __webpack_require__(74);
	
	var _News_Item2 = _interopRequireDefault(_News_Item);
	
	var _Container = __webpack_require__(20);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _InnerContainer = __webpack_require__(15);
	
	var _InnerContainer2 = _interopRequireDefault(_InnerContainer);
	
	var _SectionHeader = __webpack_require__(24);
	
	var _SectionHeader2 = _interopRequireDefault(_SectionHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewsPage = function NewsPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    _Container2.default,
	    { page: true },
	    _react2.default.createElement(
	      _InnerContainer2.default,
	      null,
	      _react2.default.createElement(
	        _SectionHeader2.default,
	        null,
	        'News and Updates'
	      ),
	      data.allContentfulNews.edges.map(function (edge, i) {
	        return _react2.default.createElement(_News_Item2.default, { key: i, news: edge.node });
	      })
	    )
	  );
	};
	
	exports.default = NewsPage;
	var query = exports.query = '** extracted graphql fragment **';
	
	// const Container = styled.div`
	//   background-color: #eee;
	//   flex-direction: column;
	//   justify-content: center;
	//   padding: 40px 10px;
	//   min-height: 100vh;
	//   font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
	// `;
	//
	// const InnerContainer = styled.div`
	//   max-width: 960px;
	//   margin: auto;
	//   padding: 20px;
	//   color: #333;
	// `;
	//
	// const SectionHeader = styled.h1`
	//   text-align: center;
	//   font-weight: 300;
	// `;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-news-js-e65a8c62b72d547a16f3.js